import { createContext, useContext, useEffect, useState } from "react";
import Cookie from "cookie-universal";
const AuthContext = createContext({});
export const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(false);
  const checkAuth = () => {
    const bearer = Cookie().get("bearer") || null;
    setIsAuth(!!bearer);
  };
  useEffect(() => {
    checkAuth();
  }, []);

  return <AuthContext.Provider value={{ isAuth, checkAuth }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => useContext(AuthContext);
